import {Component, Input} from "@angular/core";
import {VALUE_TYPE} from "../../enums/enums";
import {UI_TEXTS} from "../../enums/e-texts";
import {JP} from "../../helpers/jp";
import {getShortTimestamp} from "../../utils";


@Component({
  selector: "nv-time-params",
  templateUrl: "./nv-time-params.component.html"
})


export class NvTimeParamsComponent {
  UI_TEXTS = UI_TEXTS;
  VALUE_TYPES = VALUE_TYPE;

  private _title: string;
  private _document: any;
  private _prop: string;
  private _pointer: string;
  private _enabled: boolean;

  public _timeoutEnabled:boolean;
  public _cooldownEnabled:boolean;
  public _previewEnabled:boolean;
  public _timePeriodEnabled:boolean;

  @Input() set document(v: any) {
    //console.log('set doc');
    this._document = v;
    this.updateModel();
  }

  @Input() set pointer(v: string) {
    //console.log('set pointer');
    this._pointer = v;
    this.updateModel();
  }

  @Input() set prop(v: string) {
    this._prop = v;
    this.updateModel();
  };

  @Input() set title(v: string) {
    this._title = v;
  }

  get document() { return this._document; }
  get prop() { return this._prop; }
  get title(): string { return this._title || "No title"; }
  get pointer() { return this._pointer; }

  get timeParams() {
    return JP.get(this.document, this._pointer);
  }

  set enabled(val:boolean)
  {
    this._enabled = val;
    JP.set(this.document, "/admin/timed", val);
  }

  get enabled():boolean
  {
    return this._enabled;
  }

  set timeoutEnabled(val:boolean)
  {
    this._timeoutEnabled = val;
    JP.set(this.document, "/admin/hasTimeout", val);
  }

  get timeoutEnabled():boolean
  {
    return this._timeoutEnabled;
  }

  set cooldownEnabled(val:boolean)
  {
    this._cooldownEnabled = val;
    JP.set(this.document, "/admin/hasCooldown", val);
  }

  get cooldownEnabled():boolean
  {
    return this._cooldownEnabled;
  }

  set previewEnabled(val:boolean)
  {
    this._previewEnabled = val;
    JP.set(this.document, "/admin/hasPreview", val);
  }

  get previewEnabled():boolean
  {
    return this._previewEnabled;
  }

  set timePeriodEnabled(val:boolean)
  {
    this._timePeriodEnabled = val;
    JP.set(this.document, "/admin/hasTimePeriod", val);
  }

  get timePeriodEnabled():boolean
  {
    return this._timePeriodEnabled;
  }


  onCheckboxUpdated(val:boolean) {
    console.log(val);
    this.enabled = val;
    if (this.enabled)
    {
      JP.set(this.document, this.pointer, {});
    }
    else if (JP.has(this.document, this.pointer))
    {
      JP.remove(this.document, this.pointer);
    }
  }

  onTimeoutCheck(val:boolean){
    this.timeoutEnabled = val;
    if (this.timeoutEnabled)
    {
      JP.set(this.document, this.pointer+"/timeout",  0);
    }
    else if (JP.has(this.document, this.pointer+"/timeout"))
    {
      JP.remove(this.document, this.pointer+"/timeout");
    }
  }

  onCoodownCheck(val:boolean){
    this.cooldownEnabled = val;
    if (this.cooldownEnabled)
    {
      JP.set(this.document, this.pointer+"/cooldown",  0);
    }
    else if (JP.has(this.document, this.pointer+"/cooldown"))
    {
      JP.remove(this.document, this.pointer+"/cooldown");
    }
  }

  onPreviewCheck(val:boolean){
    this.previewEnabled = val;
    if (this.previewEnabled)
    {
      JP.set(this.document, this.pointer+"/preview",  0);
    }
    else if (JP.has(this.document, this.pointer+"/preview"))
    {
      JP.remove(this.document, this.pointer+"/preview");
    }
  }

  onTimePeriodCheck(val:boolean){
    this.timePeriodEnabled = val;
    if (!this.timePeriodEnabled)
    {
      if (JP.has(this.document, this.pointer+"/activePeriodStart"))
      {
        JP.remove(this.document, this.pointer+"/activePeriodStart");
      }
      if (JP.has(this.document, this.pointer+"/activePeriodEnd"))
      {
        JP.remove(this.document, this.pointer+"/activePeriodEnd");
      }
    }
  }


  private updateModel(): void {

    if (this.document && this.pointer)
    {
      this.enabled = JP.has(this.document, this.pointer);
      this.timeoutEnabled = JP.has(this.document, this.pointer + "/timeout");
      this.cooldownEnabled = JP.has(this.document, this.pointer + "/cooldown");
      this.previewEnabled = JP.has(this.document, this.pointer + "/preview");
      this.timePeriodEnabled = JP.has(this.document, this.pointer + "/activePeriodStart");
    }
    else
    {
      this.enabled = false;
      this.timeoutEnabled = false;
      this.cooldownEnabled = false;
      this.previewEnabled = false;
      this.timePeriodEnabled = false;
    }

  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-time-params/nv-time-params.component.ts